module.exports = "<!-- START PAGE CONTAINER -->\n<div class=\"page-container\">\n  <router-outlet></router-outlet>\n</div>\n<!-- END PAGE CONTAINER -->\n"